import { EMAIL_VALIDATION_REGEX, validatePhone } from 'src/components/Forms/validations';
import { ClientEmail, ClientPhone } from 'src/graphql/entities/client/client.types';

export interface NewClientPreseed {
  emails?: Partial<ClientEmail>[];
  phoneNumbers?: Partial<ClientPhone>[];
}

export const buildNewClientPreseed = (identity: string): NewClientPreseed => {
  if (EMAIL_VALIDATION_REGEX.test(identity)) {
    return { emails: [{ email: identity }] };
  }

  const digits = identity.replace(/\D/g, '');
  if (validatePhone(digits)) {
    return { phoneNumbers: [{ number: parseInt(digits, 10) }] };
  }

  return {};
};
